import { Button, List, ListItem, Tooltip } from "@material-ui/core";
import React from "react";
import StatisticSvg from "../Svg/StatisticSvg";
import useStyles from "./TrackableStats.style";

export default function TrackableStats({ type, stats }) {
  const classes = useStyles();

  return (
    <>
      <div>
        <Tooltip
          classes={{ tooltip: classes.tooltip }}
          title={
            <div className={classes.card}
            >
              <span className={classes.header}>Content Stats</span>
              <List style={{ width: "100%" }}>
                <ListItem className={classes.listItem}>
                  <span style={{ fontSize: "11px" }}>Category Name</span>
                  <span style={{ fontSize: "11px" }}>Content Permissions</span>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <span>{type} :</span>
                  <span className={classes.textStats}>
                    {stats.visibleCount} out of {stats.total}
                  </span>
                </ListItem>
              </List>
            </div>
          } placement="right">
          <Button>
            <StatisticSvg />
          </Button>
        </Tooltip>
      </div>
    </>
  );
}
